import Spinner from '@atlaskit/spinner';
import { N40, N700 } from '@atlaskit/theme/colors';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import styled from '@emotion/styled';
import React from 'react';
import { LayoutDefaultType } from '../../../../../model/side-information-component';

export function LayoutDefault({
  isMobile,
  isLoading,
  logo,
  isEdition,
  edition,
  isTrialTime,
  trialTime,
  showListContent,
  productListMsg
}: LayoutDefaultType) {
  return (
    <>
      {!isMobile && (
        <LogoAndEdition>
          <LogoContainer>{logo}</LogoContainer>
          {isEdition && <Edition>{edition}</Edition>}
        </LogoAndEdition>
      )}

      {showListContent && isLoading && (
        <SpinnerWrapper>
          <Spinner size="large" />
        </SpinnerWrapper>
      )}

      {isTrialTime && !isLoading && <TrialTime>{trialTime}</TrialTime>}

      {showListContent && !isLoading && (
        <FeaturesDiv>
          <SanitizedFormattedHtmlMessage {...productListMsg} />
        </FeaturesDiv>
      )}
    </>
  );
}

const FeaturesDiv = styled.div`
  div {
    font-weight: 500;
    font-family: Charlie Display, -apple-system, BlinkMacSystemFont, Segoe UI,
      Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
    font-size: 1.25rem;
    line-height: 28px;
    margin-bottom: 22px;
    color: ${N700};
  }
  ul {
    padding-left: 20px;
    padding-bottom: 10px;
    list-style-type: none;

    li {
      margin-bottom: 16px;
      position: relative;

      &::before {
        background-image: url("data:image/svg+xml,%3Csvg width='13px' height='13px' viewBox='0 0 13 13' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round'%3E%3Cg transform='translate(0.000000, -51.000000)' stroke='%230049B0' stroke-width='1.6'%3E%3Cg transform='translate(1.000000, 45.000000)'%3E%3Cg transform='translate(0.000000, 0.416810)'%3E%3Cpolyline points='1.52655666e-16 11.9766645 3.98219585 17 11 7'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        content: '';
        display: inline-block;
        position: absolute;
        left: -20px;
        top: 5px;
        height: 13px;
        width: 13px;
      }
    }
  }
`;

const TrialTime = styled.div`
  font-size: 1.25rem;
  line-height: 1.2;
  margin-bottom: 24px;
  color: ${N700};
  margin-top: 0;
  letter-spacing: 0.3px;
  font-weight: 500;
`;

const LogoContainer = styled.div`
  display: block;
  width: 100%;
  max-width: 500px;
  margin-bottom: 10px;

  canvas,
  svg {
    max-width: 100%;
  }
`;

const LogoAndEdition = styled.div`
  position: relative;
  margin-bottom: 24px;
  padding-bottom: 4px;
  border-bottom: 1px solid ${N40};
`;

const Edition = styled.div`
  font-weight: 500;
  font-family: Charlie Display, -apple-system, BlinkMacSystemFont, Segoe UI,
    Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
  font-style: normal;
  letter-spacing: 0.3px;
  margin-top: 20px;
  color: ${N700};
  font-size: 1.5rem;
  line-height: 1.33333333;
`;

const SpinnerWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
